import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

const SelectFieldStyled = withStyles((theme) => ({
  root: {
    '& label': {
      '& .MuiFormLabel-root': {
        color: theme.palette.form.labelColor,
        fontSize: theme.typography.pxToRem(14),
      },
      '& .Mui-focused': {
        color: theme.palette.primary.main,
      },
      '& .Mui-error': {
        color: theme.palette.error.main,
      },
    },
    '& .MuiSelect-select': {
      color: theme.palette.form.textColor,
      fontSize: theme.typography.pxToRem(13),
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: theme.palette.form.border,
    },
    '& .MuiFormHelperText-root': {
      fontSize: theme.typography.pxToRem(11),
    },
  },
}))(TextField);

export default SelectFieldStyled;
